var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaOpenMovil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InstaOpenMovil",
    "data-name": "Grupo 865",
    transform: "translate(0.105 0.051)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_35",
    "data-name": "Elipse 35",
    cx: 14.5,
    cy: 14.5,
    r: 12,
    transform: "translate(-0.105 -0.051)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    transform: "translate(6.672 6.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_234",
    "data-name": "Trazado 234",
    d: "M91.627,549.568H84.92a4.436,4.436,0,0,1-4.431-4.431V538.43A4.436,4.436,0,0,1,84.92,534h6.707a4.436,4.436,0,0,1,4.431,4.431v6.707A4.436,4.436,0,0,1,91.627,549.568ZM84.92,535.333a3.1,3.1,0,0,0-3.1,3.1v6.707a3.1,3.1,0,0,0,3.1,3.1h6.707a3.1,3.1,0,0,0,3.1-3.1V538.43a3.1,3.1,0,0,0-3.1-3.1Z",
    transform: "translate(-80.489 -533.999)",
    fill: "#de4628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145",
    transform: "translate(10.469 10.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_235",
    "data-name": "Trazado 235",
    d: "M118.706,576.2a3.987,3.987,0,1,1,3.986-3.987A3.991,3.991,0,0,1,118.706,576.2Zm0-6.638a2.652,2.652,0,1,0,2.652,2.652A2.655,2.655,0,0,0,118.706,569.564Z",
    transform: "translate(-114.72 -568.229)",
    fill: "#de4628"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    "data-name": "Trazado 236",
    d: "M181.4,558.5a.958.958,0,1,1-.958-.958A.958.958,0,0,1,181.4,558.5Z",
    transform: "translate(-161.826 -548.255)",
    fill: "#de4628"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaOpenMovil);
export default __webpack_public_path__ + "static/media/InstaOpenMovil.99097e8f675c742ec7b6df04205b818a.svg";
export { ForwardRef as ReactComponent };